export default function UsageBar({ label, current, limit, icon: Icon }) {
  const pct = limit ? Math.min(100, (current / limit) * 100) : 0;
  const isUnlimited = limit === null || limit === undefined;
  const isNearLimit = !isUnlimited && pct >= 80;

  return (
    <div className="space-y-1.5" data-testid={`usage-${label.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="flex items-center justify-between text-sm">
        <span className="flex items-center gap-1.5 text-gray-600">
          <Icon className="w-3.5 h-3.5" />
          {label}
        </span>
        <span className={`font-medium ${isNearLimit ? 'text-amber-600' : 'text-gray-900'}`}>
          {current}{isUnlimited ? '' : ` / ${limit}`}
          {isUnlimited && <span className="text-xs text-gray-400 ml-1">(unlimited)</span>}
        </span>
      </div>
      {!isUnlimited && (
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${isNearLimit ? 'bg-amber-500' : 'bg-teal-500'}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      )}
    </div>
  );
}
